import React from "react";
import classNames from "classnames";
import InfoTooltip from "components/InfoTooltip";
import WarningTooltip from "components/WarningTooltip";
import classes from "../styles.module.scss";

const InputSectionContainer = ({ title, info, warning, outerContainerClass, contentStyle, children }) => {
    return (
        <div className={classNames(classes.sectionContainer, outerContainerClass)}>
            <div className={classes.sectionHeader}>
                <p>{title}</p>
                {warning && <WarningTooltip warning={warning} /> }
                {info && <InfoTooltip info={info} /> }
            </div>
            <div className={classes.sectionContent} style={contentStyle ? contentStyle : {}} >
                {children}
            </div>
        </div>
    );
}

export default InputSectionContainer;